export default __webpack_public_path__ + "static/media/logo.a307e1c4.svg";